<template>
  <div class="history">
    <div
      class="days"
      v-for="(history, index) in this.histories"
      :key="index"
      :class="{ stamp: history.is_stamped == '1' }"
    >
      <div class="content">
        <div class="date">
          {{ moment(history.get_at).format('YYYY.MM.DD') }}
        </div>
        <div v-if="history.is_stamped == '0'">
          ジョイちゃんが「<span class="name">{{ history.menu_name }}</span
          >」を{{ history.amount
          }}{{ history.unit_text || '個 食べました' }}。<br />
          まんぷくメーターが <span class="point">+{{ history.amount }}</span
          >！
        </div>
        <div v-if="history.is_stamped == '1'">
          まんぷくメーターがフルになりました！「ジョイちゃんまんぷくスタンプ」をゲット。
        </div>
      </div>
      <div class="menu">
        <img class="background" :src="history.thumbnail_path" />
        <div class="point" v-if="history.amount > 1">×{{ history.amount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// import DateFormatter from '../../utils/DateFormatter.js'
import moment from 'moment'

export default {
  name: 'WalkTop',
  props: ['histories'],
  components: {},
  data: function() {
    return {}
  },
  async created() {},
  mounted: function() {},
  beforeDestroy() {},
  computed: {},
  watch: {},
  methods: {
    ...mapActions('Walk', ['actionFetchWalks']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionOpenAboutWalk',
      'actionReload'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    moment
  }
}
</script>

<style lang="scss" scoped>
.history {
  h3 {
    color: white;
    background-color: #e24241;
    font-size: 4vw;
    padding: 10px;
  }
  .days {
    &.stamp {
      background-color: #fde7e7;
    }

    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #dedede;
    .date {
      font-weight: bold;
      color: #66160E;
    }
    .content {
      text-align: left;
      flex: 1;
      .name {
        font-weight: bold;
      }
      .point {
        color: #fd9926;
        font-weight: bold;
      }
      font-size: 3.5vw;
      margin-right: 10px;
    }
    .menu {
      width: 20%;
      position: relative;
      display: flex;
      img {
        width: 100%;
        height: 100%;
      }
      .point {
        position: absolute;
        right: 0;
        bottom: 0;
        background: #fd9926;
        color: white;
        font-weight: bold;
        font-size: 4vw;
        width: 40%;
        height: 40%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 2px;
        border-radius: 50%;
      }
    }
  }
}
</style>
